/**Dependecies */
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { NavLink } from "react-router-dom";

/**Styles */
import "../styles/header.scss";

/**Others */
import logo from "../images2/logo_header.png";
import logoMobile from "../images2/logoHeaderMovil.png";
import iconLogin from "../images/icons/icon_login.png";
import { FaHeart, FaRegUserCircle } from "react-icons/fa";
import { FaPerson } from "react-icons/fa6";
import { IoPersonCircle } from "react-icons/io5";
import Swal from "sweetalert2";

/**Componente para renderizar el header*/
export const Header = () => {
  const [userData] = useState(
    JSON.parse(localStorage.getItem("dataUser")) || null
  );

  const handleLogout = () => {
    Swal.fire({
      title: "¿Estás seguro?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, cerrar sesión",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("dataUser");
        window.location.reload();
      }
    });
  };

  return (
    <>
      <Navbar expand="lg" className="navbar-custom" fixed="top">
        <div className="d-md-none d-flex mb-4 px-4 align-items-center justify-content-between w-100 shadow">
          <Navbar.Brand
            as={Link}
            to={"/"}
            className="d-flex container align-items-center m-0 justify-content-between"
          >
            <img
              src={logoMobile}
              alt=""
              width={110}
              className="d-md-block d-none"
            />
            <img src={logoMobile} alt="" className="d-md-none d-block" />
          </Navbar.Brand>
          {userData?.usuario ? (
            <>
              <NavDropdown
                title={[
                  <IoPersonCircle style={{ fontSize: "2.5rem" }} />,
                  " ",
                  userData?.usuario.nombre,
                ]}
                id="basic-nav-dropdown"
              >
                <NavDropdown.Item style={{ cursor: "default" }}>
                  Bienvenido! {userData?.usuario.nombre}{" "}
                  {userData?.usuario.apellido}
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item id="logout" onClick={handleLogout}>
                  Cerrar sesión
                </NavDropdown.Item>
              </NavDropdown>
            </>
          ) : (
            <Link
              to={"/login"}
              className="nav-link d-md-none d-block ms-auto d-lg-none text-center"
            >
              <span
                style={{
                  background: "#f8f9fa",
                  padding: "10px",
                  borderRadius: "10px",
                }}
              >
                <FaHeart color="red" style={{ marginRight: "5px" }} />
                Iniciar sesión
                <FaRegUserCircle style={{ marginLeft: "10px" }} />
              </span>
            </Link>
          )}
        </div>
        <Container>
          <Navbar.Brand
            as={Link}
            to={"/"}
            className="d-md-block d-none align-items-center m-0 justify-content-between"
          >
            <img
              src={logoMobile}
              alt=""
              width={130}
              className="d-md-block d-none"
            />
            <img src={logoMobile} alt="" className="d-md-none d-block" />
          </Navbar.Brand>
          <div className="d-none d-md-block">
            <Navbar.Toggle aria-controls="navbar-twin" />
          </div>
          <Navbar.Collapse id="navbar-twin" className="text-dark">
            {/* Links de navegación */}
            <Nav className="me-auto mx-auto align-items-center nav-links-container">
              <NavLink
                exact={"true"}
                to={"/"}
                className="nav-link text-dark text-center"
              >
                Inicio
              </NavLink>
              <NavLink
                to={"/hoteles"}
                className="nav-link text-dark text-center"
              >
                Hoteles
              </NavLink>
              <NavLink
                to={"/experiencias"}
                className="nav-link text-dark text-center"
              >
                Experiencias
              </NavLink>
              <NavLink
                to={"/traslados"}
                className="nav-link text-dark text-center"
              >
                Traslados
              </NavLink>
              <NavLink
                to={"/circuitos"}
                className="nav-link text-dark text-center"
              >
                Circuitos
              </NavLink>

              <NavLink
                to={"/renta-autos"}
                className="nav-link text-dark text-center"
              >
                Renta de autos
              </NavLink>
              {userData?.usuario ? (
                <>
                  <NavDropdown
                    title={[
                      <IoPersonCircle style={{ fontSize: "2.5rem" }} />,
                      " ",
                      userData?.usuario.nombre,
                    ]}
                    id="basic-nav-dropdown"
                  >
                    <NavDropdown.Item style={{ cursor: "default" }}>
                      Bienvenido! {userData?.usuario.nombre}{" "}
                      {userData?.usuario.apellido}
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item id="logout" onClick={handleLogout}>
                      Cerrar sesión
                    </NavDropdown.Item>
                  </NavDropdown>
                </>
              ) : (
                <>
                  <NavLink
                    to={"/login"}
                    className="nav-link text-dark text-center"
                  >
                    Iniciar sesión
                  </NavLink>
                  <NavLink
                    to={"/signup"}
                    className="nav-link text-dark  text-center"
                  >
                    <span className="rounded p-2 border-1 border border-secondary sign-up">
                      Registrase
                    </span>
                  </NavLink>
                </>
              )}
            </Nav>
          </Navbar.Collapse>
          {/* </React.Fragment> */}
          <div
            className="d-md-none d-flex text-dark mb-3"
            style={{ gap: "15px", overflowX: "auto" }}
          >
            <NavLink
              exact="true"
              to="/"
              className={({ isActive }) =>
                `nav-link text-center ${isActive ? "active" : ""}`
              }
            >
              Inicio
            </NavLink>
            <NavLink
              to="/hoteles"
              className={({ isActive }) =>
                `nav-link text-center ${isActive ? "active" : ""}`
              }
            >
              Hotel
            </NavLink>
            <NavLink
              to="/experiencias"
              className={({ isActive }) =>
                `nav-link text-center ${isActive ? "active" : ""}`
              }
            >
              Experiencias
            </NavLink>
            <NavLink
              to="/traslados"
              className={({ isActive }) =>
                `nav-link text-center ${isActive ? "active" : ""}`
              }
            >
              Traslados
            </NavLink>
            <NavLink
              to="/circuitos"
              className={({ isActive }) =>
                `nav-link text-center ${isActive ? "active" : ""}`
              }
            >
              Circuitos
            </NavLink>
            <NavLink
              to="/renta-autos"
              className={({ isActive }) =>
                `nav-link text-center ${isActive ? "active" : ""}`
              }
            >
              Renta de autos
            </NavLink>
            {!userData?.usuario && (
              <NavLink
                to="/signup"
                className={({ isActive }) =>
                  `nav-link text-center ${isActive ? "active" : ""}`
                }
              >
                <span className="rounded p-2 border-1 border border-secondary sign-up">
                  Registrarse
                </span>
              </NavLink>
            )}
          </div>
        </Container>
      </Navbar>
    </>
  );
};
